import { parse, subDays, format } from "date-fns";

export const subAndFormatDays = (
  dataString,
  amountOfDays,
  initialFormat = "yyyy-MM-dd",
  newFormat = "yyyy-MM-dd"
) => {
  const date = parse(dataString, initialFormat, new Date());
  const newDate = subDays(date, amountOfDays);
  const formatedNewDate = format(newDate, newFormat);
  return formatedNewDate;
};
